import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { RequestInit } from "atoms/models";

export const modalCancelService = async (coreTypes: Array<string>) => {
  const baseUrl = getBaseUrl();
  const queryParams = coreTypes.map((type) => `coreTypes=${encodeURIComponent(type)}`).join("&");
  const relativeUrl = `/ecommerce/route/modalCancel?${queryParams}`;
  const input = new URL(relativeUrl, baseUrl).href;

  const headers = new Headers();
  headers.append("Accept", "application/json");
  headers.append("Content-Type", "application/json");

  const body = JSON.stringify({});
  const init: RequestInit = getRequestWithTokenInformation("POST", headers, body);

  const response = await fetch(input, init);
  if (!response.ok) {
    const errorBody: any = await response.json();
    throw new Error(JSON.stringify(errorBody.message));
  }

  return await response.json();
};
